import React from "react";
import { Box, Card, Typography, Button } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

export default function PaymentFailure() {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(to bottom, #f3f6fb 60%, #e8dcc8 100%)",
      }}
    >
      <Card
        sx={{
          width: 420,
          textAlign: "center",
          padding: 4,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <CancelIcon sx={{ fontSize: 70, color: "#ef4444", mb: 2 }} />

        <Typography variant="h6" fontWeight={600}>
          Transaction Failed
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 1, mb: 3 }}
        >
          Your transaction failed. Please try again
        </Typography>

        <Button
          variant="contained"
          sx={{
            background: "#1bbf83",
            textTransform: "none",
            px: 4,
          }}
        >
          Retry Payment
        </Button>
      </Card>
    </Box>
  );
}
